// Управление пользовательским согласием на cookies / аналитику.
// Хранится в localStorage. Версия меняется при пересмотре политики -
// тогда баннер покажется повторно, чтобы пользователь дал новое согласие.

const STORAGE_KEY = 'resstro:cookie-consent';
const CONSENT_VERSION = 1;
const CHANGE_EVENT = 'resstro:consent-change';

export type ConsentChoice = {
  analytics: boolean;
  marketing: boolean;
};

export interface ConsentState extends ConsentChoice {
  version: number;
  date: string;
  necessary: true;
}

export function getConsent(): ConsentState | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentState;
    if (!parsed || parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setConsent(choice: ConsentChoice): ConsentState {
  const state: ConsentState = {
    version: CONSENT_VERSION,
    date: new Date().toISOString(),
    necessary: true,
    analytics: !!choice.analytics,
    marketing: !!choice.marketing,
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // приватный режим, игнорируем
  }
  window.dispatchEvent(new CustomEvent<ConsentState>(CHANGE_EVENT, { detail: state }));
  return state;
}

export function clearConsent() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  window.dispatchEvent(new CustomEvent<null>(CHANGE_EVENT, { detail: null }));
}

export function onConsentChange(handler: (state: ConsentState | null) => void) {
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<ConsentState | null>).detail ?? null;
    handler(detail);
  };
  window.addEventListener(CHANGE_EVENT, listener);
  return () => window.removeEventListener(CHANGE_EVENT, listener);
}

export const ALL_ACCEPTED: ConsentChoice = { analytics: true, marketing: true };
export const ONLY_NECESSARY: ConsentChoice = { analytics: false, marketing: false };
